import { Grid as MuiGrid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Grid = styled(MuiGrid)`
  max-width: 1200px;
`;
